import { ReactNode, useCallback } from 'react'
import { Skeleton } from 'antd'
import Styles from './GoogleStates.module.scss'

interface EmptyStateProps {
  cta?: ReactNode
  text: string
  subtext: string
}

export const EmptyState = ({ text, subtext, cta }: EmptyStateProps) => {
  return (
    <div className={Styles.noResultsWrapper}>
      <div className={Styles.noResults}>
        <div className={Styles.noResultsText}>{text}</div>
        <div className={Styles.noResultsSubText}>{subtext}</div>
        {!!cta && <div className={Styles.cta}>{cta}</div>}
      </div>
    </div>
  )
}

export const LoadingState = () => {
  const Loading = () => {
    return (
      <div className={Styles.content}>
        <div className={Styles.loadingImportRow}>
          <div className={Styles.loadingLeft}>
            <div className={Styles.dataLoading}>
              <div className={Styles.loadingIcon}>
                <Skeleton avatar active paragraph={false} title={false} className={Styles.loading} />
              </div>
              <div className={Styles.loadingInfoWrapper}>
                <Skeleton active paragraph={false} className={Styles.loadingInfo} />
              </div>
            </div>
          </div>
          <div className={Styles.loadingRight}>
            <div>
              <Skeleton active paragraph={false} className={Styles.loadingInfo} />
            </div>
          </div>
        </div>
      </div>
    )
  }

  const renderSkeleton = useCallback(() => [...Array(5)].map((_, i) => <Loading key={i} />), [])
  return <div>{renderSkeleton()}</div>
}
